package com.eladfinish.bible.contest.screens.browse.usecases

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.domain.BooksRepository
import com.eladfinish.bible.contest.perek_str_placeholder
import com.eladfinish.bible.contest.screens.mikud.MikudRepository
import com.eladfinish.bible.contest.utils.addGershaim
import com.eladfinish.bible.contest.utils.toOtiot
import dev.icerock.moko.resources.desc.StringDesc
import dev.icerock.moko.resources.format

class BuildChapterListUseCase(
    private val mikudRepository: MikudRepository,
) {

    operator fun invoke(index: Int): List<Pair<StringDesc, Boolean>> {
        return List(size = BooksRepository.numOfChaptersPerBook[index]) {
            SharedRes.strings.perek_str_placeholder.format(
                it.plus(1).toOtiot().addGershaim()
            ) to isChapterIncluded(bookNumber = index, chapterNumber = it)
        }
    }

    private fun isChapterIncluded(bookNumber: Int, chapterNumber: Int): Boolean =
        mikudRepository.getBookState()[bookNumber].chapters[chapterNumber]
}
